import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfirmMenuDeactivateGuard } from '@emm/shared/guards/confirm-menu-deactivate.guard';
import {MenuComponent} from '@emm/menu/components/menu/menu.component';

export const routes: Routes = [
    {
        path: '',
        component: MenuComponent,
        data: {
            title: 'EMM - Menu Data Management',
        },
        canDeactivate: [ConfirmMenuDeactivateGuard]
    }
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forChild(routes)]
})
export class MenuRoutingModule {}
